import { useState, useEffect, useRef } from "react";

const SendMessageInputWithSuggestions = ({ value, suggestions, setMessage, sendMessage }: {  value: string, suggestions: string[], setMessage: (val: string) => void, sendMessage: (messageOverride?: string) => Promise<void> }) => {
    const [currentSuggestionIndex, setCurrentSuggestionIndex] = useState(0);
    const [inputValue, setInputValue] = useState(value);
    const inputRef = useRef<any>(null);

    // Update the suggestion index periodically
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSuggestionIndex((prevIndex) => (prevIndex + 1) % suggestions.length);
        }, 3000); // Update every 3 seconds

        return () => clearInterval(interval);
    }, [suggestions.length]);

    useEffect(()=>{
        setInputValue(value);
    }, [value])

    // Handle user input
    const handleInputChange = (event: any) => {
        setInputValue(event.target.value);
        setMessage(event.target.value);
    };

    // Handle Tab key to use the suggestion
    const handleKeyDown = (event: any) => {
        if (event.key === "Tab") {
            event.preventDefault(); // Prevent default Tab behavior
            setInputValue(suggestions[currentSuggestionIndex]);
            setMessage(suggestions[currentSuggestionIndex]);
            if (inputRef.current) {
                inputRef.current.focus();
            }
        } else if (event.key === 'Enter') {
            sendMessage(inputValue);
            setInputValue('');
            setMessage('');
        }
    };

    return (
        <div className="relative">
            <input
                id="send-message-input"
                type="text"
                className="w-full border-2 border-gray-200 rounded-2xl py-4 px-6 pr-20 text-gray-900 placeholder-gray-400 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200 bg-white shadow-sm"
                value={inputValue}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                placeholder={suggestions[currentSuggestionIndex] || 'Ask PocketQuant'}
                ref={inputRef}
                data-hj-allow
            />
            <button
                disabled={!inputValue.trim()}
                onClick={() => {
                    sendMessage(inputValue)
                    setInputValue('');
                    setMessage('');
                }}
                className={`absolute right-3 top-1/2 transform -translate-y-1/2 px-4 py-2 rounded-xl font-medium transition-all duration-200 ${
                    inputValue.trim() 
                        ? 'bg-blue-500 text-white hover:bg-blue-600 shadow-sm hover:shadow-md' 
                        : 'bg-gray-100 text-gray-400 cursor-not-allowed'
                }`}
            >
                Send
            </button>
        </div>
    );
};

export default SendMessageInputWithSuggestions;
